export enum InputTypes {
    TEXT = 'text',
    EMAIL = 'email',
    SELECT = 'select',
}